import TranslationService from "../../../ceres/services/TranslationService";
import Vue from "vue";
import { mapState } from "vuex";

const NotificationService = require("../../../ceres/services/NotificationService");

export default Vue.component("shipping-privacy-hint-check", {
	props: {
		template: {
			type: String,
			default: "#vue-shipping-privacy-hint-check"
		},
		hintMode: {
			type: String,
			default: "popper"
		}
	},

	computed: {
		currentShippingProfile() {
			return this.shippingProfileList.find(profile => profile.parcelServicePresetId === this.shippingProfileId);
		},

		currentPrivacyHints() {
			if (this.currentShippingProfile && this.currentShippingProfile.shippingPrivacyInformation) {
				return this.currentShippingProfile.shippingPrivacyInformation.filter(
					entry => !!entry.showDataPrivacyAgreementHint
				);
			}

			return [];
		},

		privacyHintContent() {
			const andTranslation = TranslationService.translate("Ceres::Template.checkoutShippingPrivacyHintAnd");

			let parcelServiceInformation = "";

			for (const hint of this.currentPrivacyHints) {
				if (parcelServiceInformation !== "") {
					parcelServiceInformation += ` ${andTranslation} `;
				}

				parcelServiceInformation += `<strong>${hint.parcelServiceName}`;

				if (hint.parcelServiceAddress.length) {
					parcelServiceInformation += `, ${hint.parcelServiceAddress} `;
				}

				parcelServiceInformation += `</strong>`;
			}

			return TranslationService.translate("Eros::Template.checkoutShippingPrivacyHint", {
				parcelServiceInformation
			});
		},

		...mapState({
			shippingProfileList: state => state.checkout.shipping.shippingProfileList,
			shippingProfileId: state => state.checkout.shipping.shippingProfileId,
			shippingPrivacyHintAccepted: state => state.checkout.shippingPrivacyHintAccepted
		})
	},

	methods: {
		setValue(value) {
			this.$store.commit("setShippingPrivacyHintAccepted", value);
		}
	},

	watch: {
		currentShippingProfile(value, oldValue) {
			const defaultValue = (typeof App?.Eros?.Config?.checkout?.acceptShippingPrivacyByDefault !== "undefined" ? App.Eros.Config.checkout.acceptShippingPrivacyByDefault : true);

			if (this.shippingPrivacyHintAccepted !== defaultValue && value.parcelServiceId !== oldValue.parcelServiceId) {
				this.setValue(defaultValue);

				$(this.$refs.formCheck)
					.fadeTo(100, 0.1)
					.fadeTo(400, 1.0);

				NotificationService.error(
					TranslationService.translate("Ceres::Template.checkoutShippingPrivacyReseted")
				);
			} else if (value && !value.shippingPrivacyInformation[0].showDataPrivacyAgreementHint) {
				this.setValue(defaultValue);
			}
		}
	}
});
